import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://kakobuyspreadsheet.website";
const FAVICON_URL = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png";

export default function HoodieGuidePage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "Kakobuy Spreadsheet Hoodie Guide: Find the Best Quality Sweaters 2026",
    "description": "Your complete resource for finding premium hoodies and sweaters through our curated Kakobuy spreadsheet listings with fabric quality tips and seasonal recommendations.",
    "author": {
      "@type": "Organization",
      "name": "Kakobuy Spreadsheet Team"
    },
    "datePublished": "2026-06-25",
    "dateModified": "2026-06-25",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": SITE_URL + "/guide/hoodie-guide"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Kakobuy Spreadsheet",
      "logo": {
        "@type": "ImageObject",
        "url": FAVICON_URL
      }
    },
    "image": "https://readdy.ai/api/search-image?query=A%20perfectly%20folded%20heather%20gray%20hoodie%20placed%20on%20a%20light%20oak%20wooden%20surface%20beside%20a%20steaming%20ceramic%20mug%20of%20coffee%20and%20a%20pair%20of%20reading%20glasses%20soft%20afternoon%20light%20coming%20from%20a%20nearby%20window%20creating%20a%20cozy%20lifestyle%20scene%20editorial%20photography%20with%20warm%20autumn%20tones&width=1400&height=600&seq=article-hoodie-v2-05&orientation=landscape"
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />
      <Navbar />
      <main>
        <article className="pt-24 md:pt-28">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-foreground-900 transition-colors mb-6 cursor-pointer">
              <i className="ri-arrow-left-line text-sm"></i>Back to Kakobuy Spreadsheet Home
            </Link>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4">Hoodie Guide</span>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4 text-balance">
              <span className="text-primary-500">Kakobuy Spreadsheet</span> Hoodie Guide: Find the Best Quality Sweaters
            </h1>
            <div className="flex items-center gap-4 text-xs text-foreground-500 mb-8 pb-6 border-b border-background-200/70">
              <span>Last Updated: June 25, 2026</span><span className="w-1 h-1 rounded-full bg-foreground-400"></span><span>5 min read</span>
            </div>
          </div>

          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="relative rounded-2xl overflow-hidden aspect-[21/9] mb-8">
              <img src="https://readdy.ai/api/search-image?query=A%20perfectly%20folded%20heather%20gray%20hoodie%20placed%20on%20a%20light%20oak%20wooden%20surface%20beside%20a%20steaming%20ceramic%20mug%20of%20coffee%20and%20a%20pair%20of%20reading%20glasses%20soft%20afternoon%20light%20coming%20from%20a%20nearby%20window%20creating%20a%20cozy%20lifestyle%20scene%20editorial%20photography%20with%20warm%20autumn%20tones&width=1400&height=600&seq=article-hoodie-v2-05&orientation=landscape"
                alt="Kakobuy Spreadsheet Hoodie Guide" className="w-full h-full object-cover rounded-2xl" loading="lazy" />
            </div>

            <section className="mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">How to Find Quality Hoodies on Kakobuy</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                The hoodie category in our <strong>Kakobuy Spreadsheet</strong> features over 1,800 listings spanning everything from lightweight pullovers to heavy winter fleece. Quality varies significantly between listings, which is why our spreadsheet includes detailed fabric weight, material composition, and stitching quality notes for each entry.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                When browsing hoodies in the <strong>Kakobuy Spreadsheet</strong>, pay close attention to the GSM (grams per square meter) rating in the product details column. Higher GSM numbers indicate thicker, warmer fabric. For everyday wear, look for 280-350 GSM hoodies; for premium heavyweight options, seek out those rated 400 GSM or above.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                The brand comparison section of our <strong>Kakobuy Spreadsheet</strong> is particularly useful for hoodie shoppers. It shows how each listing compares to well-known retail brands, helping you understand exactly what level of quality to expect before making a purchase.
              </p>
            </section>

            <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer">
                <i className="ri-home-4-line text-sm"></i>Back to Homepage
              </Link>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-700 text-sm font-medium rounded-lg hover:border-foreground-400 transition-all duration-300 whitespace-nowrap cursor-pointer">
                Browse Spreadsheet <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}